import { AssetManager } from 'components/sharpr/assetManager/AssetManager';

export function SsoNoAccessRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.SsoNoAccess', {
		url: '/sso/no-access/:code/:email',
		controllerAs: 'vm',
		controller: SsoNoAccessCtrl,
		templateUrl: '/ng/hub/Sso/NoAccess/SsoNoAccessCtrl.html?' + window.BUILD,
		permission: [],
		resolve: {
			style: () => AssetManager.css('/ng/hub/Sso/NoAccess/SsoNoAccessCtrl.css'),
			$title: () => 'One More Step',
		},
	});
}

export class SsoNoAccessCtrl {
	constructor($stateParams) {
		'ngInject';
		this.code = $stateParams.code;
		this.email = $stateParams.email;
		const subject = encodeURIComponent('I need access to Sharpr');
		const body = encodeURIComponent(
			`I logged in to Sharpr as ${this.email} but have access to no hubs. The SSO code is ${this.code}.\n\n`
		);
		this.mailto = `mailto:support@sharpr.com?subject=${subject}&body=${body}`;
	}
}
